
/* System defined core library */
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';

/* User defined library/components */
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/modules/shared.module';
import { AppComponent } from './app.component';
import { SchedulingModule } from './scheduling/scheduling.module';
import { WebpackTranslateLoader } from '../webpack-translate-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AccordionModule } from 'ngx-bootstrap/accordion';

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        AppRoutingModule,
        CoreModule,
        SharedModule,
        BrowserAnimationsModule,
        AccordionModule,
        SchedulingModule.forRoot(), // add root to have only one DI
        ReactiveFormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: WebpackTranslateLoader,
                deps: [HttpClient]
            }
        })
    ],
    //providers: [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }, { provide: APP_BASE_HREF, useValue: '/' },
    providers: [{ provide: APP_BASE_HREF, useValue: '/' },
        Title
    ],
    bootstrap: [AppComponent],
})
export class AppModule { }
